module.exports = __webpack_public_path__ + "static/media/Brookwood-Village-Bylaws.3969e536.pdf";